import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Box, Button, FlexBox, IconButton, List, } from '@dixa/lib-shared-habla';
import { Link } from 'react-router-dom';
import { numberFormatterInternational } from 'app/utils/telephonyHelpers';
import { Highlight } from 'components/highlight';
import styles from './contactPreview.module.scss';
const isUser = (hit) => typeof hit.roles !== 'undefined';
/** Represents a component that is used to preview an individual contact */
export const ContactPreview = ({ hit, onGoToContact, onPreviewClose, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!hit)
        return null;
    const { name, company, email, phone } = isUser(hit)
        ? {
            name: ((_b = (_a = hit._highlights) === null || _a === void 0 ? void 0 : _a.display_name) === null || _b === void 0 ? void 0 : _b[0]) || hit.display_name || '',
            company: ((_d = (_c = hit._highlights) === null || _c === void 0 ? void 0 : _c.company) === null || _d === void 0 ? void 0 : _d[0]) || hit.company,
            email: ((_f = (_e = hit._highlights) === null || _e === void 0 ? void 0 : _e.email) === null || _f === void 0 ? void 0 : _f[0]) || hit.email,
            phone: ((_h = (_g = hit._highlights) === null || _g === void 0 ? void 0 : _g.phone_number) === null || _h === void 0 ? void 0 : _h[0]) || hit.phone_number,
        }
        : {
            name: ((_k = (_j = hit._highlights) === null || _j === void 0 ? void 0 : _j.name) === null || _k === void 0 ? void 0 : _k[0]) || hit.name || '',
            company: null,
            email: null,
            phone: null,
        };
    const renderUserDetails = () => {
        var _a;
        if (!isUser(hit))
            return null;
        const items = [
            {
                key: 'Email',
                value: email ? _jsx(Highlight, { highlightedValue: email }) : null,
            },
            {
                key: 'Phone Number',
                value: phone ? (_jsx(Highlight, { highlightedValue: numberFormatterInternational({
                        phoneNumber: phone,
                    }) })) : null,
            },
            {
                key: 'Roles',
                value: _jsx("span", Object.assign({ className: styles.roles }, { children: (_a = hit.roles) === null || _a === void 0 ? void 0 : _a.join(', ') })),
            },
            {
                key: 'Company',
                value: hit.company && (_jsx(Link, Object.assign({ to: `/contacts/company/${hit.company_id}` }, { children: company ? _jsx(Highlight, { highlightedValue: company }) : null }))),
            },
        ];
        return (_jsx(Box, Object.assign({ margin: "300 0 0 0", padding: "0 300" }, { children: _jsx(List, { children: items.map((item, index) => (_jsx(List.KeyValue, { pair: item, withHoverEffect: false }, index))) }) })));
    };
    return (_jsxs(_Fragment, { children: [_jsxs(FlexBox, Object.assign({ justifyContent: "space-between", alignItems: "center", padding: "300 400" }, { children: [_jsx("div", Object.assign({ className: styles.boldText }, { children: "Contact" })), _jsxs("div", Object.assign({ className: styles.actions }, { children: [_jsx(Button, Object.assign({ variant: "secondary", onClick: onGoToContact }, { children: "Go to contact" })), _jsx(IconButton, { icon: "close", variant: "secondary", onClick: onPreviewClose })] }))] })), _jsxs(FlexBox, Object.assign({ alignItems: "center", padding: "0 300" }, { children: [_jsx(Avatar, { user: hit, className: styles.avatar }), _jsxs("div", { children: [_jsx("div", Object.assign({ className: styles.boldText }, { children: _jsx(Highlight, { highlightedValue: name }) })), email && (_jsx("div", Object.assign({ className: styles.grayText }, { children: _jsx(Highlight, { highlightedValue: email }) })))] })] })), renderUserDetails()] }));
};
